import React from 'react';
import { colors } from '../../styles/colors';
import { BaseIcon } from '../base/BaseIcon';
import type { EvoCreditIconProps } from './types';

export const EvoCreditHIcon = React.memo<EvoCreditIconProps>(
  ({
    className = '',
    size = 24,
    width,
    height,
    color = colors.gtred[500],
    onClick,
    title = 'EvoCredit',
    'aria-hidden': ariaHidden = false,
  }) => {
    const clipPathId = `evocredit-h-${React.useId()}`;

    return (
      <BaseIcon
        className={className}
        size={size}
        width={width}
        height={height}
        color={color}
        onClick={onClick}
        viewBox="0 0 24 24"
        aria-hidden={ariaHidden}
      >
        {!ariaHidden && title && <title>{title}</title>}
        <defs>
          <clipPath id={clipPathId}>
            <rect width="24" height="24" fill="none" />
          </clipPath>
        </defs>
        <g clipPath={`url(#${clipPathId})`}>
          <path
            d="M23.897,12.715l-1.85-6.942c-.468-1.748-1.779-3.14-3.479-3.719L11.631.184h-.001c-1.864-.5-3.856.035-5.223,1.401L1.583,6.412C.218,7.777-.316,9.769.185,11.636l1.768,6.592c.5,1.865,1.959,3.322,3.825,3.822l6.592,1.767h0c1.865.499,3.857-.036,5.224-1.402h0l4.825-4.826c1.28-1.28,1.829-3.111,1.48-4.873h-.002ZM20.721,15.891l-4.825,4.826c-.758.758-1.871,1.057-2.904.78l-6.593-1.766c-1.036-.277-1.851-1.091-2.128-2.125l-1.768-6.592c-.277-1.036.02-2.149.776-2.905l4.825-4.827c.758-.758,1.871-1.057,2.904-.78l6.784,1.824c.944.322,1.677,1.098,1.937,2.066l1.812,6.787c.193.979-.112,2.002-.821,2.711h0Z"
            fill={color}
          />
          <path
            d="M12.074,6.001c-1.139,0-2.184.259-3.104.772-.92.512-1.654,1.23-2.179,2.134-.525.903-.791,1.94-.791,3.082s.27,2.182.802,3.092c.531.91,1.297,1.631,2.277,2.144.98.514,2.129.774,3.416.774,2.078-.009,3.571-.722,4.725-1.949l-1.933-1.933c-.381.336-.777.587-1.178.747-.429.171-.935.258-1.504.258-.797,0-1.466-.175-1.988-.519-.524-.346-.92-.97-1.103-1.602h8.459c.028-.343.033-.681.02-1.013-.044-1.13-.322-2.183-.807-3.082-.959-1.779-2.726-2.953-5.112-2.907v.002ZM9.461,10.977c.264-3.003,5.009-3.003,5.273,0h-5.273Z"
            fill={color}
          />
        </g>
      </BaseIcon>
    );
  },
);

EvoCreditHIcon.displayName = 'EvoCreditHIcon';
